import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

/**
 * ExternalUrlRouteGuard can be used to allow angular router to handle external url in a similar manner to angular routes
 **/
@Injectable()
export class ExternalUrlRouteGuard  {

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const externalUrl = route.paramMap.get('externalUrl');
    window.open(externalUrl, '_self');
    return false;
  }

  constructor() { }

}
